<template>
  <div class="transactions-table">
    <div class="transactions-table__header">
      <span>
        {{ $t("Transactions") }}
      </span>
    </div>
    <div class="transactions-table__content">
      <VTable :headers="headers" :items="items" with-index>
        <template #hash="{ item }">
          <router-link :to="getLink(item)" exact>
            {{ item.hash || "" }}
          </router-link>
        </template>
        <template #amount="{ item }">
          {{ formatAmount(item.amount, decimals) }}
        </template>
      </VTable>
    </div>
  </div>
</template>

<script>
import { amount as formatAmount } from "@/shared/utils/format/amount";
import { VTable } from "@/shared/ui/VTable";

export default {
  name: "TransactionsTable",
  components: { VTable },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    decimals: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      formatAmount,
      headers: [
        { key: "type", text: "Type", width: "1fr" },
        { key: "amount", text: "Amount", width: "1fr" },
        { key: "hash", text: "Hash", width: "5fr" },
        { key: "status", text: "Status", width: "1fr" },
        { key: "time", text: "Date", width: "1.5fr" },
      ],
    };
  },
  methods: {
    getLink(item) {
      return { path: `/${item.network}/transaction/${item.hash}` };
    },
  },
};
</script>

<style scoped lang="scss">
.transactions-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);
    padding: 16px 0;

    span {
      font-size: 16px;
      font-weight: 600;
      color: rgb(255, 255, 255);
      line-height: 130%;
      text-align: left;
      word-break: break-all;
    }
  }

  &__content {
    a {
      text-decoration: underline;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
    }
  }
}
</style>
